module.exports = __webpack_public_path__ + "static/media/ladies_accessories_9.708303fd.jpg";